import { createGlobalStyle } from "styled-components";

export const AutoagendamientoV2Styles = createGlobalStyle`
  body {
    background-color: #E7EBEE!important;
    color: ${({ theme }) => theme.colors.typho.colorLabel};
    font-family: ${({ theme }) => theme.font};
  }
  .body-1{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font};
  }
  .ft-monserratbold{
    font-family: Montserrat-Bold
  }
  .d-banner-1{
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 500px;
    display: flex;
  }
  .d-1,
  .d-2{
    width: 50%
  }
  .d-logo-center{
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
  }

  button {
    padding: 7px 28px;
    font-size: 14px;
    border-radius: 5px!important;
    margin-top: 5px;
    border: 0;
    background-color: ${({ theme }) => theme.colors.button.background};
    color: ${({ theme }) => theme.colors.button.text};
  }

  button:hover:enabled {
      background-color: ${({ theme }) => theme.colors.button.hover};
  }
  button:focus:enabled,
  button:active:enabled {
    background-color: ${({ theme }) => theme.colors.button.active};
  }
  button.declined {
    padding: 7px 28px;
    font-size: 14px;
    border-radius: 0px!important;
    border: 0;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.button.declined};
    font-weight: 600;
  }

  button.declined:hover:enabled {
      background-color: transparent;
  }
  button.declined:focus:enabled,
  button.declined:active:enabled {
    background-color: transparent;
  }
  .colorLabel{
    color: ${({ theme }) => theme.colors.typho.colorLabel}!important;
  }

  .bg-level1{
    background-color: ${({ theme }) => theme.colors.background.bgLevel1};
  }
  .colorLink{
    color: ${({ theme }) => theme.colors.typho.colorLink};
  }
  .colorTitle{
    color: ${({ theme }) => theme.colors.typho.colorTitle};
  }
  .colorOrange{
    color: ${({ theme }) => theme.colors.typho.colorOrange};
  }
  .borderColorLabel{
    border-color: ${({ theme }) => theme.colors.typho.colorLabel};
  }
  .date-time-help{
    font-size: 2rem;
    font-weight: 700;
  }
  .phone2 .form-input,
  .form-input{
    display: block;
    border-radius: 5px!important;
    width: 100%!important;
    padding: 0.375rem 0.75rem;
    font-size: .9rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    letter-spacing: 1px;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid ${({ theme }) =>
      theme.colors.button.bgBorderActive}!important
  }
  .form-input:focus,
  .form-input:focus-visible{
    border: 1px solid ${({ theme }) =>
      theme.colors.button.bgBorderActive}!important;
    box-shadow: none!important;
    outline: none!important
  }
  .form-input:disabled{
    background-color: #e9ecef;
    opacity: 1;
  }
  .btn-phone2{
    background: #fff!important;
    border-right: 0!important;
    border-color: #2a7ec3!important;
  }
  .fw-medium{
    font-weight: 600
  }
  label,
  .label{
    color: #000000;
  }
  a.label:hover{
    color: #000000!important;
  }
  .text-underline{
    text-decoration: underline;
  }
  .bg-footer{
    background-color: #67B1ED;
  }
  .footer-label{
    color: #fff;
    line-height: 1.2
  }
  .circle-1{
    display: inline-block;
    height: 65px;
    width: 65px;
    background-color: #fff;
    border-radius: 50%;
  }
  .opacity--3{
    opacity: .3;
  }
  .absolute-1{
    position: absolute;
    right: 13px;
    top: -7px;
  }
  .circle-2{
    display: inline-block;
    height: 115px;
    width: 115px;
    background-color: #fff;
    border-radius: 50%;
  }
  .opacity--2{
    opacity: .2;
  }
  .absolute-2{
    position: absolute;
    right: -11px;
    top: -31px;
  }
  .circle-3{
    display: inline-block;
    height: 145px;
    width: 145px;
    background-color: #fff;
    border-radius: 50%;
  }
  .opacity--3{
    opacity: .1;
  }
  .absolute-3{
    position: absolute;
    right: -19px;
    top: -38px;
  }
  .absolute-4{
    position: absolute;
    right: -19px;
    bottom: -46px;
  }
  .absolute-5{
    position: absolute;
    right: -46px;
    bottom: -83px;
  }
  .absolute-6{
    position: absolute;
    right: -53px;
    bottom: -97px;
  }
  .absolute-7{
    position: absolute;
    left: -19px;
    bottom: -46px;
  }
  .absolute-8{
    position: absolute;
    left: -46px;
    bottom: -83px;
  }
  .absolute-9{
    position: absolute;
    left: -53px;
    bottom: -97px;
  }
  .bg-footer-1{
    background-color: #3E8DF6;
    background-image: linear-gradient(to left, #031E64 30% , #3E8DF6);
  }
  .hr-1{
    background-color: #fff;
    width: 80%;
    margin: auto;
    height: 2px;
  }
  .fs--7{
    font-size: .7rem
  }
  .div-footer{
    margin-top: auto;
  }
  #countdown {
    position: relative;
    margin: auto;
    height: 100px;
    width: 100px;
    text-align: center;
  }
  
  #countdown-number {
    color: #fff;
    display: block;
    line-height: 95px;
    z-index: 99999;
    position: inherit;
  }
  
  #countdown svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    transform: rotateY(-180deg) rotateZ(-90deg);
  }
  
  #countdown svg circle {
    stroke-dasharray: 249px;
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 4px;
    stroke: #F5972A;
    fill: #2A7EC3;
  }
  
  @keyframes countdown {
    from {
      stroke-dashoffset: 0px;
    }
    to {
      stroke-dashoffset: 249px;
    }
  }
  .title-1{
    font-size:54px;
    font-weight: 700;
  }
  .title-2{
    font-size:54px;
  }
  .pos-title{
    padding-left: 18rem;
  }
  .column--50-first{
    padding-top: 10rem;
    padding-left: 11rem;
  }
  .box-time{
    border: 1px solid #707070;
    height: 35px;
    opacity: 1;
    width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    font-size: .9rem;
    cursor: pointer;
  }
  .box-time-active{
    border-color: #F5972A;
    box-shadow: inset 0px 5px 3px #0000001A;
  }
  .vl {
    border-left: 2px solid #707070;
    height: 24px;
  }
  .tiempo-validez{
    width: 40%;
    margin: auto;
    background: #fff;
    border-radius: 5px;
    padding: 10px; 
    position: relative
  }
  .card-dinamic{
    width: 60%;
    padding: 10px;
    background: #fff;
    margin:auto;
    margin-top:10px;
  }
  .mt--20{
    margin-top: -15%
  }
  .fs-1--2{
    font-size: 1.2rem
  }
  .borderColorStar{
    border-color: #F5972A;
  }
  .bgColorStar{
    border-color: #F5972A
  }
  .modalSuccessV2 .modal-content{
    border: 0!important
  }
  .img-doctors{    
    height: 80px;
    width: 80px;
    background-color: #f5972a;
    padding: 3px;
    border-radius: 50%;
    object-fit: cover;
    object-position: top;
  }
  .doctor-list{
    width: 80%;
    margin: auto;
  }
  .fw-700{
    font-weight: 700;
  }

  @media (min-width:768px) {
    .banner-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 991.98px){
    .pos-title{
      padding-left: 4rem;
    }
  }
  @media (max-width: 1200px){
    .mt--20{
      margin-top: -10%;
    }
  }

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) { 
    .pos-title{
      padding-left: 3rem;
    } 
    .column--50-first{
      padding-top: 5rem;
      padding-left: 3rem;
    }
    .pos-title{
      padding-left: 4rem;
    }
  }
  // Small devices (landscape phones, 576px and up)
  @media (max-width: 576px) { 
    .d-banner-1{
      height: 250px;
    }
    .pos-title{
      padding-left: 2rem;
    }
    .column--50-first{
      padding-top: 1rem;
      padding-left: 2rem;
    }
    .mt--20{
      margin-top: -5%;
    }
    .tiempo-validez{
      width: 90%; 
    }
    .d-logo-center{
      display: none
    }
    .d-1{
      width: 100%;
    }
  }
  button:disabled{
    color: #fff;
    opacity: .65;
    cursor: not-allowed
  }
  
`;
